/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import QRCode from '@bitcoin-portal/bitcoincom-pkg-components/dist/QRCode';
import { Helmet } from 'react-helmet';
import { useBranchLink } from '../../../helpers/branchLink';
import { handleRipple } from '../../../helpers/ripple';
import {
  StyledSection,
  LoaderWrapper,
  LoaderImage,
  ContentWrapper,
  Title,
  Subtitle,
  ButtonsWrapper,
  DownloadButton,
  StoreButton,
  StoreIcon,
  QRWrapper,
  QRCode as StyledQRCode,
  StoreButtonsRow,
  MobileButton,
  StyledButton,
  StyledGoArrowLeft,
} from './styled';

const Download = ({ locale }) => {
  const { messages } = useIntl();
  const [loading, setLoading] = useState(true);
  const [branchLinkWorking, setBranchLinkWorking] = useState(false);

  const mobileButtonLink = useBranchLink({
    branch: messages['home.header.link.mobile_button'],
    android: messages['home.header.link.googleplay'],
    iOS: messages['home.header.link.appstore'],
    fallback: messages['home.header.link.mobile_button'],
  });

  const branchLink =
    'https://bitcoincom.app.link/KE0EQAPrqAb?_p=c11433dc9a0a7af2e21590f4ec';

  useEffect(() => {
    const handleRedirection = () => {
      const attemptRedirect = () => {
        try {
          window.location.href = branchLink;
        } catch (error) {
          if (mobileButtonLink && mobileButtonLink !== branchLink) {
            window.location.href = mobileButtonLink;
          } else {
            setLoading(false);
          }
        }
      };

      setTimeout(() => {
        attemptRedirect();

        setTimeout(() => {
          setLoading(false);
        }, 3000);
      }, 1000);
    };

    handleRedirection();
  }, [messages, branchLink, mobileButtonLink]);

  if (loading) {
    return (
      <StyledSection>
        <LoaderWrapper>
          <LoaderImage
            src={messages['global.downloadpage.loading.src']}
            alt={messages['global.downloadpage.loading.alt']}
          />
        </LoaderWrapper>
      </StyledSection>
    );
  }

  const handleDownloadClick = () => {
    window.open(branchLink, '_blank');
  };

  const handleAppStoreClick = () => {
    window.open(
      messages['global.downloadpage.store_buttons.app_store.link'],
      '_blank',
    );
  };

  const handlePlayStoreClick = () => {
    window.open(
      messages['global.downloadpage.store_buttons.google_play.link'],
      '_blank',
    );
  };

  return (
    <>
      <Helmet>
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf"
          as="font"
          type="font/ttf"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@500..900&family=Noto+Sans:ital,wdth,wght@0,75..100,500..900;1,62.5..100,500..900&display=swap"
          rel="stylesheet"
          key="google-fonts2"
        />

        <style>
          {`
                @font-face {
                  font-family: 'Elza Condensed';
                  src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: 'Satoshi Variable Medium';
                  src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
                  font-weight: normal;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: 'Chivo Mono';
                  src: url('https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf') format('truetype');
                  font-weight: normal;
                  font-style: normal;
                  font-display: swap;
                }
              `}
        </style>
      </Helmet>
      <StyledSection>
        <ContentWrapper>
          <Title locale={locale}>{messages['global.downloadpage.title']}</Title>
          <Subtitle>{messages['global.downloadpage.subtitle']}</Subtitle>
          <ButtonsWrapper>
            <StoreButtonsRow>
              <StoreButton onClick={handleAppStoreClick}>
                <StoreIcon
                  src={
                    messages['global.downloadpage.store_buttons.app_store.src']
                  }
                  alt={
                    messages['global.downloadpage.store_buttons.app_store.alt']
                  }
                />
              </StoreButton>

              <StoreButton onClick={handlePlayStoreClick}>
                <StoreIcon
                  src={
                    messages[
                      'global.downloadpage.store_buttons.google_play.src'
                    ]
                  }
                  alt={
                    messages[
                      'global.downloadpage.store_buttons.google_play.alt'
                    ]
                  }
                />
              </StoreButton>
            </StoreButtonsRow>
          </ButtonsWrapper>

          <QRWrapper>
            <StyledQRCode>
              <QRCode value={branchLink} />
            </StyledQRCode>
            <p>{messages['global.downloadpage.qr.description']}</p>
          </QRWrapper>

          <MobileButton
            href={messages['global.downloadpage.return_link.url']}
            onMouseEnter={handleRipple}
          >
            <StyledGoArrowLeft />
            {messages['global.downloadpage.return_link.text']}
          </MobileButton>
          <StyledButton
            href={messages['global.downloadpage.return_link.url']}
            onMouseEnter={handleRipple}
          >
            <StyledGoArrowLeft />
            {messages['global.downloadpage.return_link.text']}
          </StyledButton>
        </ContentWrapper>
      </StyledSection>
    </>
  );
};

Download.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default Download;
